<template>
  <div class="sos-form">
    <img height="91" class="title" src="@/assets/images/zxcImg/zxcTitle2.png" />
    <p class="cor-gray">
      美菜SOS精准扶贫全国采购计划：旨在紧急助销滞销农产品，帮助其拓宽销售渠道，让陷入绝望的滞销菜农重新燃起希望。
    </p>
    <el-form
      :model="unsalablesForm"
      :rules="rules"
      ref="unsalablesForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="滞销菜名称" prop="vegetablesName">
            <el-input v-model="unsalablesForm.vegetablesName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="滞销菜详细位置（省/市/县）" prop="address">
            <el-input v-model="unsalablesForm.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="上市时间" prop="startTime">
            <br />
            <el-date-picker
              v-model="unsalablesForm.startTime"
              type="date"
              placeholder="选择日期"
              value-format="timestamp"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下市时间" prop="endTime">
            <br />
            <el-date-picker
              v-model="unsalablesForm.endTime"
              type="date"
              placeholder="选择日期"
              value-format="timestamp"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="现售价格（元）" prop="salesPrice">
            <el-input v-model="unsalablesForm.salesPrice"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="去年同期价格（元）" prop="lastYearPrice">
            <el-input v-model="unsalablesForm.lastYearPrice"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="滞销量（吨）" prop="unsoldWeight">
            <el-input v-model="unsalablesForm.unsoldWeight"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="种植面积（亩）" prop="plantingArea">
            <el-input v-model="unsalablesForm.plantingArea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="总产量（吨）" prop="totalWeight">
            <el-input v-model="unsalablesForm.totalWeight"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适合销售的最近城市" prop="salesCity">
            <el-input v-model="unsalablesForm.salesCity"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人" prop="username">
            <el-input v-model="unsalablesForm.username"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="unsalablesForm.mobile"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="上传菜品图片（单张不要超过5M，最多上传6张）"
            prop="imageUrls"
          >
            <el-upload
              action="/apiApp/profile"
              list-type="picture-card"
              :on-success="handleSuccess"
              :limit="6"
              :on-remove="handleRemove"
              accept=".jpg,.png"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="图片验证" prop="captcha">
            <el-input v-model="unsalablesForm.captcha"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" style="padding-top: 25px">
          <img :src="captchaSrc" />
          <i class="el-icon-refresh" @click="refresh"></i>
        </el-col>
      </el-row>
      <el-form-item style="margin-top: 20px">
        <el-button type="success" @click="commit">提交信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mixinsVerification } from "@/mixins/verification";
export default {
  name: "sosForm",
  mixins: [mixinsVerification],
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    return {
      unsalablesForm: {
        username: "",
        mobile: "",
        vegetablesName: "",
        address: "",
        startTime: "",
        endTime: "",
        salesPrice: "",
        lastYearPrice: "",
        unsoldWeight: "",
        plantingArea: "",
        totalWeight: "",
        salesCity: "",
        imageUrls: "",
        captcha: "",
      },
      visbility: this.dialogVisbility,
      rules: {
        username: [
          { required: true, message: "请输入司机姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkTel, trigger: "blur" },
        ],
        vegetablesName: [
          { required: true, message: "请输入滞销菜名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细位置", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择上市时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择下市时间", trigger: "blur" },
        ],
        salesPrice: [
          { required: true, message: "请输入现售价格", trigger: "blur" },
        ],
        lastYearPrice: [
          { required: true, message: "请输入去年同期价格", trigger: "blur" },
        ],
        unsoldWeight: [
          { required: true, message: "请输入滞销量", trigger: "blur" },
        ],
        plantingArea: [
          { required: true, message: "请输入种植面积", trigger: "blur" },
        ],
        totalWeight: [
          { required: true, message: "请输入总产量", trigger: "blur" },
        ],
        salesCity: [
          {
            required: true,
            message: "请输入适合销售的最近城市",
            trigger: "blur",
          },
        ],
        // imageUrls: [
        //   { required: true, message: "请上传菜品图片", trigger: "blur" },
        // ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (this.unsalablesForm.imageUrls) {
        this.unsalablesForm.imageUrls += "," + response.data.furl;
      } else {
        this.unsalablesForm.imageUrls = response.data.furl;
      }
    },
    handleRemove(file, fileList) {
      if (this.unsalablesForm.imageUrls.indexOf(",") != -1) {
        this.unsalablesForm.imageUrls.replace(
          "," + file.response.data.furl,
          ""
        );
      } else {
        this.unsalablesForm.imageUrls = "";
      }
    },
    commit() {
      this.$refs.unsalablesForm.validate((valid) => {
        if (valid) {
          let captcha = this.unsalablesForm.captcha;
          let pramas = Object.assign({}, this.unsalablesForm);
          delete pramas.captcha;
          this.unsalablesForm.startTime = new Date(
            this.unsalablesForm.startTime
          ).getTime();
          this.unsalablesForm.endTime = new Date(
            this.unsalablesForm.endTime
          ).getTime();
          _api.all.createUnsalables(pramas, { captcha }).then((res) => {
            this.refresh();
            this.$message({
              message: "提交信息成功",
              type: "success",
            });
            this.$refs.unsalablesForm.resetFields();
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.sos-form {
  background-color: #f8fefc;
  padding: 30px 90px 50px;
  margin: 50px auto 0;
  width: 1000px;
  .title {
    display: block;
    margin: 0 auto;
  }
  .cor-gray {
    text-align: left;
  }
  .el-form-item {
    margin: 5px 0;
    .el-input__inner {
      height: 30px;
    }
  }
  .el-form-item__label {
    padding: 0;
    line-height: 30px;
    height: 30px;
    float: left;
  }
  .el-icon-refresh {
    font-size: 20px;
  }
  .el-button {
    width: 200px;
    background: #64bd89;
  }
}
</style>